import { Modal } from 'src/components/restructure/product/utils/Modal'
import Icon from 'src/components/ui/Icon'
import './PickupModal.scss'

import type { PickupPoint } from '../useFreightSimulation'
import { PickupPointList } from './PickupModalList'

type Props = {
  isOpen: boolean
  pickupPoints: PickupPoint
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>
}

export function PickupModal({ isOpen, setOpenModal, pickupPoints }: Props) {
  const { recommend: recommendedPickupPoints, others: otherPickupPoints } =
    pickupPoints

  const handleCloseModal = () => {
    setOpenModal(false)
    document.body.style.overflowX = 'hidden'
    document.body.style.overflowY = 'auto'
  }

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={handleCloseModal}
        className="w-full flex flex-col h-full scrollModalAnimation overflow-hidden restructure-tablet:max-w-[435px] !justify-start"
        positionContent="top-right"
      >
        <header className="w-full flex items-center justify-between py-6 px-5">
          <p className="text-[18px] leading-[27px] font-semibold text-restructure-primary ">
            Opções de retirada
          </p>
          <button
            className="h-[48px]"
            aria-label="close modal"
            onClick={handleCloseModal}
          >
            <Icon name="FreightClose" width={24} height={24} />
          </button>
        </header>
        <p className="text-tertiary text-font-size-2 py-4 px-5 mx-md bg-[#F5F4F5] mb-12">
          Você pode retirar em qualquer loja ou ponto que o produto esteja
          disponível num raio de até 50km.
        </p>
        <main className="overflow-y-auto min-h-none flex flex-col gap-[46px]">
          {recommendedPickupPoints.length > 0 && (
            <>
              <PickupPointList
                pickupPoints={recommendedPickupPoints}
                title="Recomendados"
                handleCloseModal={handleCloseModal}
              />
              <PickupPointList
                pickupPoints={otherPickupPoints}
                title="Outras opções"
                handleCloseModal={handleCloseModal}
              />
            </>
          )}
          {recommendedPickupPoints.length === 0 && (
            <PickupPointList
              pickupPoints={otherPickupPoints}
              title=""
              isTitleVisible={false}
              handleCloseModal={handleCloseModal}
            />
          )}
        </main>
      </Modal>
    </>
  )
}
